var parse = require('../parse/index.js')

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(cleanDate.getFullYear(), 0, 1, 0, 0, 0, 0)
  return date
}

module.exports = startOfYear



/*****************
 ** WEBPACK FOOTER
 ** ./~/date-fns/start_of_year/index.js
 ** module id = 420
 ** module chunks = 1
 **/